import styled from "@emotion/styled";
import { InteractiveText } from "@silvertours/front-shared";
var CollapseToggleWrapper = /*#__PURE__*/ styled(InteractiveText, {
    target: "ecjf3ho0"
})("display:flex;flex-direction:row;align-items:center;gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";");
var StyledButton = /*#__PURE__*/ styled("button", {
    target: "ecjf3ho1"
})("z-index:20;", function(param) {
    var isCollapsed = param.isCollapsed;
    return isCollapsed ? "padding-top: ".concat(function(param) {
        var theme = param.theme;
        return theme.spacing[70];
    }) : "\n  margin-top: -3rem;\n  position: absolute;\n  ";
}, "  background-color:#0000;border:none;cursor:pointer;");
export { CollapseToggleWrapper, StyledButton };
